export default __webpack_public_path__ + "static/media/Corona.869cf6e2.jpg";